import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_HERO_GROUP_SELLING_REQUEST =
  'HeroGroupSelling/FETCH_HERO_GROUP_SELLING_REQUEST'
const FETCH_HERO_GROUP_SELLING_SUCCESS =
  'HeroGroupSelling/FETCH_HERO_GROUP_SELLING_SUCCESS'
const FETCH_HERO_GROUP_SELLING_FAILURE =
  'HeroGroupSelling/FETCH_HERO_GROUP_SELLING_FAILURE'

const FETCH_HERO_ADDRESS_BY_ID_REQUEST =
  'HeroGroupSelling/FETCH_HERO_ADDRESS_BY_ID_REQUEST'
const FETCH_HERO_ADDRESS_BY_ID_SUCCESS =
  'HeroGroupSelling/FETCH_HERO_ADDRESS_BY_ID_SUCCESS'
const FETCH_HERO_ADDRESS_BY_ID_FAILURE =
  'HeroGroupSelling/FETCH_HERO_ADDRESS_BY_ID_FAILURE'

const FETCH_HERO_ADDRESS_ALL_REQUEST =
  'HeroGroupSelling/FETCH_HERO_ADDRESS_ALL_REQUEST'
const FETCH_HERO_ADDRESS_ALL_SUCCESS =
  'HeroGroupSelling/FETCH_HERO_ADDRESS_ALL_SUCCESS'
const FETCH_HERO_ADDRESS_ALL_FAILURE =
  'HeroGroupSelling/FETCH_HERO_ADDRESS_ALL_FAILURE'

const FETCH_BANK_ALL_REQUEST =
  'HeroGroupSelling/FETCH_BANK_ALL_REQUEST'
const FETCH_BANK_ALL_SUCCESS =
  'HeroGroupSelling/FETCH_BANK_ALL_SUCCESS'
const FETCH_BANK_ALL_FAILURE =
  'HeroGroupSelling/FETCH_BANK_ALL_FAILURE'

const FETCH_HERO_BANK_BY_ID_REQUEST =
  'HeroGroupSelling/FETCH_HERO_BANK_BY_ID_REQUEST'
const FETCH_HERO_BANK_BY_ID_SUCCESS =
  'HeroGroupSelling/FETCH_HERO_BANK_BY_ID_SUCCESS'
const FETCH_HERO_BANK_BY_ID_FAILURE =
  'HeroGroupSelling/FETCH_HERO_BANK_BY_ID_FAILURE'

const FETCH_HERO_BANK_ALL_REQUEST =
  'HeroGroupSelling/FETCH_HERO_BANK_ALL_REQUEST'
const FETCH_HERO_BANK_ALL_SUCCESS =
  'HeroGroupSelling/FETCH_HERO_BANK_ALL_SUCCESS'
const FETCH_HERO_BANK_ALL_FAILURE =
  'HeroGroupSelling/FETCH_HERO_BANK_ALL_FAILURE'

const FETCH_HERO_PO_DELIVER_BY_ID_REQUEST =
  'HeroGroupSelling/FETCH_HERO_PO_DELIVER_BY_ID_REQUEST'
const FETCH_HERO_PO_DELIVER_BY_ID_SUCCESS =
  'HeroGroupSelling/FETCH_HERO_PO_DELIVER_BY_ID_SUCCESS'
const FETCH_HERO_PO_DELIVER_BY_ID_FAILURE =
  'HeroGroupSelling/FETCH_HERO_PO_DELIVER_BY_ID_FAILURE'

const FETCH_HERO_PO_DELIVER_ALL_REQUEST =
  'HeroGroupSelling/FETCH_HERO_PO_DELIVER_ALL_REQUEST'
const FETCH_HERO_PO_DELIVER_ALL_SUCCESS =
  'HeroGroupSelling/FETCH_HERO_PO_DELIVER_ALL_SUCCESS'
const FETCH_HERO_PO_DELIVER_ALL_FAILURE =
  'HeroGroupSelling/FETCH_HERO_PO_DELIVER_ALL_FAILURE'

const UPDATE_HERO_PO_DELIVER_STATUS_REQUEST = 'HeroGroupSelling/UPDATE_HERO_PO_DELIVER_STATUS_REQUEST'
const UPDATE_HERO_PO_DELIVER_STATUS_SUCCESS = 'HeroGroupSelling/UPDATE_HERO_PO_DELIVER_STATUS_SUCCESS'
const UPDATE_HERO_PO_DELIVER_STATUS_FAILURE = 'HeroGroupSelling/UPDATE_HERO_PO_DELIVER_STATUS_FAILURE'

const UPDATE_HERO_PO_DETAIL_REQUEST = 'HeroGroupSelling/UPDATE_HERO_PO_DETAIL_REQUEST'
const UPDATE_HERO_PO_DETAIL_SUCCESS = 'HeroGroupSelling/UPDATE_HERO_PO_DETAIL_SUCCESS'
const UPDATE_HERO_PO_DETAIL_FAILURE = 'HeroGroupSelling/UPDATE_HERO_PO_DETAIL_FAILURE'

const UPDATE_HERO_PO_REQUEST = 'HeroGroupSelling/UPDATE_HERO_PO_REQUEST'
const UPDATE_HERO_PO_SUCCESS = 'HeroGroupSelling/UPDATE_HERO_PO_SUCCESS'
const UPDATE_HERO_PO_FAILURE = 'HeroGroupSelling/UPDATE_HERO_PO_FAILURE'

const DELETE_HERO_PO_REQUEST = 'HeroGroupSelling/DELETE_HERO_PO_REQUEST'
const DELETE_HERO_PO_SUCCESS = 'HeroGroupSelling/DELETE_HERO_PO_SUCCESS'
const DELETE_HERO_PO_FAILURE = 'HeroGroupSelling/DELETE_HERO_PO_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  heroSellingList: [],
  heroSellingTotal: 0,
  heroAddress: [],
  heroAddressList: [],
  bankList: [],
  herobank: [],
  herobankList: [],
  poDeliverList: [],
  poDeliverObj: {}
}

// Default Reducer
const heroGroupSelling = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HERO_GROUP_SELLING_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_GROUP_SELLING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroSellingList: action.payload.content || [],
        heroSellingTotal: action.payload.totalElements || 0
      }
    case FETCH_HERO_GROUP_SELLING_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_HERO_PO_DELIVER_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_PO_DELIVER_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        poDeliverObj: action.payload
      }
    case FETCH_HERO_PO_DELIVER_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_HERO_PO_DELIVER_ALL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_PO_DELIVER_ALL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        poDeliverList: action.payload
      }
    case FETCH_HERO_PO_DELIVER_ALL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_HERO_PO_DELIVER_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_HERO_PO_DELIVER_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_HERO_PO_DELIVER_STATUS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_HERO_PO_DETAIL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_HERO_PO_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_HERO_PO_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_HERO_ADDRESS_ALL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_ADDRESS_ALL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroAddressList: action.payload
      }
    case FETCH_HERO_ADDRESS_ALL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_HERO_ADDRESS_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_ADDRESS_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroAddress: action.payload
      }
    case FETCH_HERO_ADDRESS_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case FETCH_BANK_ALL_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case FETCH_BANK_ALL_SUCCESS:
        return {
          ...state,
          isLoading: false,
          bankList: action.payload
        }
      case FETCH_BANK_ALL_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
    case FETCH_HERO_BANK_ALL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_BANK_ALL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        herobankList: action.payload
      }
    case FETCH_HERO_BANK_ALL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_HERO_BANK_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_BANK_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        herobank: action.payload
      }
    case FETCH_HERO_BANK_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_HERO_PO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_HERO_PO_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_HERO_PO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_HERO_PO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_HERO_PO_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_HERO_PO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default heroGroupSelling

// Action Creators
export const fetchHeroSellingList = (page = 0, size = 20, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_GROUP_SELLING_REQUEST
      })

      const params = { page, size }
      if (filters.status) params.status = filters.status
      if (filters.materialName) params.materialName = filters.materialName
      if (filters.heroName) params.heroName = filters.heroName
      if (filters.type) params.type = filters.type

      const data = await API.get(EndPoints.HERO_GROUP_SELLING + `/admin/heroPo`, { params })
      dispatch({
        type: FETCH_HERO_GROUP_SELLING_SUCCESS,
        payload: data.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_GROUP_SELLING_FAILURE
      })
    }
  }
}
export const getPoDeliverById = (poDeliverId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_PO_DELIVER_BY_ID_REQUEST
      })
      const response = await API.get(EndPoints.HERO_GROUP_SELLING + `/poDeliver/${poDeliverId}`)
      dispatch({
        type: FETCH_HERO_PO_DELIVER_BY_ID_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_PO_DELIVER_BY_ID_FAILURE
      })
    }
  }
}
export const fetchPoDeliverList = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_PO_DELIVER_ALL_REQUEST
      })

      const data = await API.get(EndPoints.HERO_GROUP_SELLING + `/poDeliver/searchAll`, {
        params: options
      })
      dispatch({
        type: FETCH_HERO_PO_DELIVER_ALL_SUCCESS,
        payload: data.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_PO_DELIVER_ALL_FAILURE
      })
    }
  }
}
export const fetchHeroAddressList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_ADDRESS_ALL_REQUEST
      })

      const data = await API.get(EndPoints.HERO_GROUP_SELLING + `/accountAddress/all`)
      dispatch({
        type: FETCH_HERO_ADDRESS_ALL_SUCCESS,
        payload: data.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_ADDRESS_ALL_FAILURE
      })
    }
  }
}

export const getHeroAddressById = (heroId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_ADDRESS_BY_ID_REQUEST
      })
      const response = await API.get(EndPoints.HERO_GROUP_SELLING + `/accountAddress/${heroId}`)
      dispatch({
        type: FETCH_HERO_ADDRESS_BY_ID_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_ADDRESS_BY_ID_FAILURE
      })
    }
  }
}
export const fetchBankList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BANK_ALL_REQUEST
      })

      const data = await API.get(EndPoints.HERO_GROUP_SELLING + `/bankAccount/all`)
      dispatch({
        type: FETCH_BANK_ALL_SUCCESS,
        payload: data.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BANK_ALL_FAILURE
      })
    }
  }
}

export const fetchHeroBankList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_BANK_ALL_REQUEST
      })

      const data = await API.get(EndPoints.HERO_GROUP_SELLING + `/heroBankAccount/all`)
      dispatch({
        type: FETCH_HERO_BANK_ALL_SUCCESS,
        payload: data.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_BANK_ALL_FAILURE
      })
    }
  }
}

export const getHeroBankById = (heroId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_BANK_BY_ID_REQUEST
      })
      const response = await API.get(EndPoints.HERO_GROUP_SELLING + `/heroBankAccount/${heroId}`)
      dispatch({
        type: FETCH_HERO_BANK_BY_ID_SUCCESS,
        payload: response.data
      })
      console.log(response.data)
    } catch (err) {
      dispatch({
        type: FETCH_HERO_BANK_BY_ID_FAILURE
      })
    }
  }
}

export const updatePODStatus = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_HERO_PO_DELIVER_STATUS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HERO_GROUP_SELLING + `/poDeliver/admin/editStatus`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_HERO_PO_DELIVER_STATUS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_HERO_PO_DELIVER_STATUS_FAILURE
      })
    }
  }
}
export const updatePODetail = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_HERO_PO_DETAIL_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HERO_GROUP_SELLING + `/heroPo/admin/updateDetail`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_HERO_PO_DETAIL_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_HERO_PO_DETAIL_FAILURE
      })
    }
  }
}
export const updateHeroPo = (data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: UPDATE_HERO_PO_REQUEST })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HERO_GROUP_SELLING + `/heroPo/admin/updateHeroPo`, { items: [data] }, {
        headers: { Authorization: authorizationHeader }
      })
      dispatch({ type: UPDATE_HERO_PO_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({ type: UPDATE_HERO_PO_FAILURE })
    }
  }
}

export const deletePO = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_HERO_PO_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.HERO_GROUP_SELLING + `/heroPo/admin/deletePo/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_HERO_PO_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_HERO_PO_FAILURE
      })
    }
  }
}
